import { yup } from '@framework/validation/initYup.ts';
import { ComputedDateExpressionSchema } from '../../../../expressions/repository/computed-date/ComputedDateExpressionSchema.ts';
import { WidgetType } from '../../../Widget.ts';
import { CommonInputWidgetConfigSchema } from '../../inputs/common/CommonInputConfigComponent.tsx';
import { type IComputedDateWidget } from '../IComputedWidget.ts';

export const computedDateConfigSchema: yup.ObjectSchema<IComputedDateWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().required().exact(WidgetType.ComputedDate).label('Tipo'),
    expression: ComputedDateExpressionSchema.required().label('Espressione'),
  });
